import { createSlice } from "@reduxjs/toolkit";
import { getUsers, getAllDealers, deleteUser } from "./_userAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isDeleting: false,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

const dealerListInitialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: ''
};

export const userList = createSlice({
  name: "userList",
  initialState: initialState,
  reducers: {
    clearState: (state) => {
      state.data = [];
      state.isLoading = false;
      state.isSuccess = false;
      state.responseCode = null;
      state.responseMessage = '';
      state.totalRecord = 0;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getUsers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getUsers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(deleteUser.pending, (state) => {
        state.isDeleting = true;
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.isDeleting = false;
      })
      .addCase(deleteUser.rejected, (state) => {
        state.isDeleting = false;
      })
  },
});

export const dealerList = createSlice({
  name: "dealerList",
  initialState: dealerListInitialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllDealers.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getAllDealers.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
      })
      .addCase(getAllDealers.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
